(() => {
  if (!document.body.classList.contains('template-index') || window.__ccHomeMeasurement) return;
  window.__ccHomeMeasurement = true;
  const destination = 'G-FNLWPWC433';
  const version = 'home-launch-showcase-2026-10-29';
  const labels = {
    slideshow: 'Main banner', cc_featured_offer: 'Top offers', blocks_YzpXfk: 'Why shop with us',
    collection_list_jhMw6h: 'Shop by need', video_collection_4HH87t: 'See it in action',
    featured_collection_UeWqrx: 'Best sellers', featured_collection_qcyUrC: 'Latest arrivals',
    codex_home_finder: 'Product finder', 'rich-text-0': 'About us',
    '1729232745d4bbf3cf': 'Customer reviews', featured_blog_pJmAdQ: 'Advice hub'
  };
  const preview = () => Boolean(window.Shopify?.designMode || document.querySelector('#PBarNextFrame') || new URLSearchParams(location.search).has('preview_theme_id'));
  const allowed = () => !preview() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const sections = new Map();
  const pending = new Map();
  function emit(name, section, detail = {}) {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    const data = sections.get(section);
    if (!data) return false;
    try {
      window.gtag('event', name, { send_to: destination, home_block_id: data.id, home_block_name: data.label, home_block_position: data.position, home_layout_version: version, ...detail });
      return true;
    } catch (_) { return false; }
  }
  function view(section) {
    const data = sections.get(section);
    if (data && !data.seen) data.seen = emit('cc_home_view', section);
  }
  function origin(element) {
    const section = element.closest('#MainContent > .shopify-section');
    if (sections.has(section)) return section;
    return null;
  }
  function classify(button) {
    if (button.matches('[data-quantity-change], .quantity__button') || /quantity/i.test(button.getAttribute('aria-label') || '')) return null;
    if (button.matches('[type="submit"]') && button.closest('form[action*="/cart/add"]')) return 'basket_button';
    if (button.matches('.cc-offer__toggle')) return 'more_offers';
    const label = button.getAttribute('aria-label') || button.textContent || '';
    if (/quick view|quick add|choose options/i.test(label)) return 'quick_view';
    if (/slide|previous|next/i.test(label)) return 'carousel';
    if (/play|pause|video/i.test(label)) return 'video_control';
    return 'other_button';
  }
  function register() {
    document.querySelectorAll('#MainContent > .shopify-section').forEach((section, index) => {
      if (sections.has(section)) return;
      const id = section.id.split('__').pop();
      sections.set(section, { id, label: labels[id] || 'Other homepage section', position: index + 1, seen: false, visible: false, timer: null });
      observer?.observe(section);
    });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const data = sections.get(entry.target);
      if (!data) continue;
      data.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
      if (!data.visible) { clearTimeout(data.timer); data.timer = null; }
      else if (!data.seen && !data.timer) data.timer = setTimeout(() => { data.timer = null; if (data.visible) view(entry.target); }, 1000);
    }
  }, { threshold: 0.25 }) : null;
  register();
  const retryVisible = () => sections.forEach((data, section) => { if (data.visible) view(section); });
  document.addEventListener('visitorConsentCollected', retryVisible);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], retryVisible);
  let attempts = 0;
  const retry = setInterval(() => { retryVisible(); if (++attempts >= 15) clearInterval(retry); }, 2000);
  document.addEventListener('shopify:section:load', register);
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button,summary,quick-view-button');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    const section = origin(target);
    if (!section || !allowed()) return;
    if (target.tagName === 'A') {
      let url;
      try { url = new URL(target.href, location.origin); } catch (_) { return; }
      if (!['https:', 'http:'].includes(url.protocol)) return;
      view(section);
      emit('cc_home_click', section, { home_target_path: url.origin === location.origin ? url.pathname : 'external', home_action: target.dataset.quickView === 'true' ? 'quick_view' : /\/products\//.test(url.pathname) ? 'product_link' : /\/collections\//.test(url.pathname) ? 'collection_link' : 'other_link' });
    } else {
      const action = classify(target);
      if (!action) return;
      view(section);
      emit('cc_home_interaction', section, { home_action: action });
    }
  }, true);
  const played = new WeakSet();
  document.addEventListener('play', event => {
    const video = event.target;
    const section = origin(video);
    if (video.tagName !== 'VIDEO' || !section || !allowed() || played.has(video)) return;
    if (emit('cc_home_interaction', section, { home_action: 'video_play' })) played.add(video);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-cc-offer-form')) return;
    const section = origin(form);
    if (!section || !allowed()) return;
    const variant = form.querySelector('[name="id"]')?.value;
    if (!/^\d+$/.test(variant || '')) return;
    pending.set(variant, { section, time: Date.now(), quantity: Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1) });
  }, true);
  document.addEventListener('cc:offer-added', event => {
    const section = origin(event.target);
    if (section) emit('cc_home_add_to_cart', section, { home_action: 'offer_basket_add', variant_id: String(event.detail.variant_id), items_added: event.detail.items_added, value: event.detail.value, currency: event.detail.currency });
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartError, data => pending.delete(String(data.productVariantId)));
    subscribe(PUB_SUB_EVENTS.cartUpdate, data => {
      if (data.source !== 'product-form' || !data.cart || data.cart.status) return;
      const variant = String(data.productVariantId);
      const candidate = pending.get(variant);
      pending.delete(variant);
      if (!candidate || Date.now() - candidate.time > 30000) return;
      emit('cc_home_add_to_cart', candidate.section, { home_action: 'product_basket_add', variant_id: variant, items_added: candidate.quantity });
    });
  }
})();
